import { AddOns } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectIsDomainWhiteListed, selectUserAddOns } from "user/profile/selectors"

export const useAddOnRestricted = (addOnType?: AddOns) => {
    const addOns = useAppSelector(selectUserAddOns)
    const isWhitelisted = useAppSelector(selectIsDomainWhiteListed)

    let isRestricted = false
    if (addOnType && Object.values(AddOns).includes(addOnType) && !isWhitelisted) {
        isRestricted = !addOns[addOnType]
    }
    return { isRestricted }
}
